import { updateNotificationConfig } from "services/companyAPI";

export function registerPushNotification(user) {
  // Verifică dacă browserul acceptă notificările push
  if ("PushManager" in window) {
    // console.log("Browserul acceptă notificări push.");

    // Solicită permisiunea
    Notification.requestPermission()
      .then((permission) => {
        if (permission === "granted") {
          // console.log("Permisiune acordată pentru notificările push.");

          // Permisiune acordată, continuăm cu abonarea
          // Este posibil să fie necesar un service worker înregistrat

          navigator.serviceWorker.ready.then((registration) => {
            // console.log("Service worker gata pentru a se abona.");

            registration.pushManager
              .subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(
                  process.env.REACT_APP_PUSH_KEY
                ),
              })
              .then((subscription) => {
                // console.log("Abonament la notificări push creat cu succes.");

                // Crearea obiectului de subscription pentru server
                const subscriptionObject = {
                  endpoint: subscription.endpoint,
                  keys: {
                    p256dh: uint8ArrayToBase64(subscription.getKey("p256dh")),
                    auth: uint8ArrayToBase64(subscription.getKey("auth")),
                  },
                  encoding: PushManager.supportedContentEncodings,
                  /* alte date specifice aplicației, cum ar fi identitatea utilizatorului */
                };

                // Log pentru a verifica datele de subscription
                // console.log(
                //   "Obiectul de subscription:",
                //   JSON.stringify(subscriptionObject)
                // );
                // console.log("Utilizatorul:", user);

                // Trimite datele de subscription către server
                updateNotificationConfig("push", subscriptionObject)
                  .then((response) => {
                    // console.log(
                    //   "Configurația notificărilor actualizată cu succes:",
                    //   response
                    // );
                  })
                  .catch((error) => {
                    console.error(
                      "Eroare la actualizarea configurației notificărilor:",
                      error
                    );
                  });
              })
              .catch((error) => {
                // console.error(
                //   "Eroare la abonarea la notificările push:",
                //   error
                // );
              });
          });
        } else {
          // console.log(
          //   "Permisiunea pentru notificările push nu a fost acordată."
          // );
        }
      })
      .catch((error) => {
        console.error("Eroare la cererea permisiunii de notificare:", error);
      });
  } else {
    // console.log("Browserul nu acceptă notificările push.");
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function uint8ArrayToBase64(buffer) {
  var binary = "";
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}
